import { render, staticRenderFns } from "./seasonBonusDetail.vue?vue&type=template&id=35f5d078&scoped=true"
import script from "./seasonBonusDetail?vue&type=script&lang=js&external"
export * from "./seasonBonusDetail?vue&type=script&lang=js&external"
import style0 from "./seasonBonusDetail.vue?vue&type=style&index=0&id=35f5d078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5d078",
  null
  
)

export default component.exports